import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CoinflipDeprecatedService } from './coinflip.service';
import { CoinflipStatsComponent } from './coinflip-stats/coinflip-stats.component';
import { CoinflipInfoBarComponent } from './coinflip-info-bar/coinflip-info-bar.component';
import { CoinflipRowComponent } from './coinflip-row/coinflip-row.component';
import { listAnimation } from '@core/utils/animations.util';
import { CoinflipWinNotificationContainerComponent } from '@features/coinflip/components/coinflip-win-notification-container/coinflip-win-notification-container.component';

@Component({
  selector: 'app-coinflip',
  templateUrl: './coinflip.component.html',
  styleUrls: ['./coinflip.component.scss'],
  imports: [
    CoinflipStatsComponent,
    CoinflipInfoBarComponent,
    CoinflipRowComponent,
    CoinflipWinNotificationContainerComponent,
  ],
  standalone: true,
  animations: [listAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoinflipComponent {
  public deprecatedCoinflipService = inject(CoinflipDeprecatedService);

  constructor() {
    this.deprecatedCoinflipService.initializeCoinflipHistory();
  }
}
